export const encodedData = (a) => window.btoa(a)
export const decodedData = (b) => window.atob(b)
